import { VisualizatorSettings } from "./visualizator-settings";
import { ObjectCreator } from "../../../../../web-graphics";

export class VisualizatorCoreSettings extends VisualizatorSettings {
  constructor(settings) {
    super();
    this.minSupportedVersion = "2.0.0";
    this.modeSettings = new Map(); // key: mode, value: settings
    for (const key of Object.getOwnPropertyNames(settings)) {
      if (key == "version") {
        this.version = settings.version;
      } else if (key == "mode") {
        this.mode = settings.mode;
      } else if (key == "modeSettings") {
        settings.modeSettings.forEach((value, key) => {
          this.modeSettings.set(key, value);
        });
      } else if (key == "view") {
        this.view = settings.view.copy();
      } else if (key == "data") {
        this.data = settings.data.copy();
      } else {
        if (typeof settings[key] === "object" && settings[key].copy !== undefined) {
          this[key] = settings[key].copy();
        } else if (typeof settings[key] !== "function") {
          this[key] = ObjectCreator.deepCopy(settings[key]);
        }
      }
    }
  }

  copy() {
    return new VisualizatorCoreSettings(this);
  }
}
